
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { EVSidebarService } from '../ev-sidebar/ev-sidebar.service';

@Component({
  selector: 'app-ev-basket',
  templateUrl: './ev-basket.component.html',
  styleUrls: ['./ev-basket.component.scss'],
  standalone: true,
  imports: [MatToolbarModule, MatIconModule],
})
export class EvBasketComponent implements OnInit {
  public items = [
    { id: 1, name: 'Observation result ABC', size: '560kb' },
    { id: 2, name: 'Observation result GDH', size: '1.2mb' },
    { id: 3, name: 'Observation result FWIJ', size: '10.6mb' },
    { id: 4, name: 'Observation result FWEOFJ', size: '23kb' },
    { id: 5, name: 'Observation result KOEF', size: '231kb' },
    { id: 6, name: 'Observation result WOQ', size: '25mb' },
    { id: 7, name: 'Observation result 598', size: '62mb' },
    { id: 1, name: 'Observation result ABC', size: '560kb' },
    { id: 2, name: 'Observation result GDH', size: '1.2mb' },
    { id: 3, name: 'Observation result FWIJ', size: '10.6mb' },
    { id: 4, name: 'Observation result FWEOFJ', size: '23kb' },
    { id: 5, name: 'Observation result KOEF', size: '231kb' },
    { id: 6, name: 'Observation result WOQ', size: '25mb' },
    { id: 7, name: 'Observation result 598', size: '62mb' },
    { id: 1, name: 'Observation result ABC', size: '560kb' },
    { id: 2, name: 'Observation result GDH', size: '1.2mb' },
    { id: 3, name: 'Observation result FWIJ', size: '10.6mb' },
    { id: 4, name: 'Observation result FWEOFJ', size: '23kb' },
  ];

  constructor(private readonly sidebarService: EVSidebarService) {}

  ngOnInit() {
    // console.log('items array: ', this.items.length);
  }
  public closeSidePanel() {
    this.sidebarService.clearSidebarMode();
  }

  deleteItem(item) {
    this.items.splice(item, 1);
    // console.log('items array: ', this.items.length);
  }

  deleteAll() {
    this.items = [];
  }
}
